import { combineReducers } from "redux";
import AuthReducer from "./AuthReducer";
import BillingApprove from "./BillingApproveReducer";
import FiltersReducer from "./FiltersReducer";
import IntegrationsReducer from "./IntegrationsReducer";
import MapPayrollReducer from "./MapPayrollReducer";
import MapPropertiesReducer from "./MapPropertiesReducer";
import MapStaffsReducer from "./MapStaffsReducer";
import MapTaskRuleReducer from "./MapTaskRulesReducer";
import SyncLogsReducer from "./SyncLogsReducer";
import TimeTrackingReducer from "./TimeTrackingReducer";
import TranslationsReducer from "./TranslationsReducer";
import ZapierReducer from "./ZapierReducer";

/*mobile dashboard */
import AppFeaturesReducer from "./AppFeaturesReducer";
import MobileDasboardTabsReducer from "./MobileDasboardTabsReducer";
import MobileDashboardReducer from "./MobileDashboardReducer";
import UnscheduledTaskReducer from "./UnscheduledTaskReducer";
import SsoAuthReducer from "./SsoAuthReducer";
import CognitoUserDataReducer from "./CognitoUserDataReducer";

const rootReducer = combineReducers({
  AuthReducer,
  IntegrationsReducer,
  MapPropertiesReducer,
  MapPayrollReducer,
  MapStaffsReducer,
  FiltersReducer,
  MapTaskRuleReducer,
  BillingApprove,
  TimeTrackingReducer,
  SyncLogsReducer,
  MobileDashboardReducer,
  MobileDasboardTabsReducer,
  UnscheduledTaskReducer,
  TranslationsReducer,
  ZapierReducer,
  AppFeaturesReducer,
  CognitoUserDataReducer,
  SsoAuthReducer,
});

export default rootReducer;
